export default __webpack_public_path__ + "static/media/laundry1-afterA-768w.9f676845.avif";